import ajax from 'axios';
import { Message } from 'element-ui';
//http request 拦截器
ajax.interceptors.request.use(
    config => {
        if(location.hash.indexOf('careerevalution')>0||location.hash.indexOf('parent')>0||location.hash.indexOf('studyPlan')>0||location.hash.indexOf('consultant')>0||location.hash.indexOf('learningAbility')>0||location.hash.indexOf('shengyaceping')>0){
            showLoading()
        }
        return config;
    },
    error => {
        hideLoading()
        return Promise.reject(err);
    }
);


//http response 拦截器
ajax.interceptors.response.use(
    response => {
        hideLoading()
        if (response.data.code == 2000||response.data.code ==0||response.data.code ==2026) {

        }else{
            if(response&&response.data&&response.data.msg){
                if(location.hash.includes('login')||location.hash.includes('register')) {

                }else {
                    // Message.error(response.data.msg);
                }
            }
        }
        return response;
    },
    error => {
        hideLoading()
        return Promise.reject(error)
    }
)
// 当前正在请求的数量
let requestCount = 0
// 显示loading
function showLoading () {
    if (requestCount === 0) {
        $('#public_Loading').show();
    }
    requestCount++
}

// 隐藏loading
function hideLoading () {
    requestCount--
    if (requestCount === 0) {
        $('#public_Loading').hide()
    }
}
export default ajax